/**
 * @example {{ 'text' | uppercase }}
 */
export default function (value, arg) {
  return value ? value.toUpperCase() : value;
}
